import React, { useEffect, useState } from "react";
import { Images } from "../../helper/images";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const ClinetAssistanceChannel = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.CLIENT_ASSISTANCE_CHANNEL}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/faq'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.FAQS}</p></DisabledNavLink>
                </div>
            </div>
            <div className="col-md-3 mx-auto mb-4">
                <div><img src={Images.leaf} className="w-100" alt="" /></div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <div className="border p-3 rounded">
                        <div className="d-flex align-items-center gap-2">
                            <div className="mr-2"><img src={Images.user} width="30" height="30" alt="" /></div>
                            <p className="p-0 text-dark">Sarb Parhar</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="border p-3 rounded">
                        <div className="d-flex align-items-center gap-2">
                            <div className="mr-2"><img src={Images.email} width="28" height="28" alt="" /></div>
                            <a href="mailto:Sarb.Parhar@incorporation.ai" className="text-dark">Sarb.Parhar@incorporation.ai</a>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="border p-3 rounded">
                        <div className="d-flex align-items-center gap-2">
                            <div className="mr-2"><img src={Images.phone} width="30" height="30" alt="" /></div>
                            <a href="tel:14165743800" className="text-dark">1.416.574.3800</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ClinetAssistanceChannel;
